import {Input, Modal, Row, Col} from 'antd';
import {useState} from "react";

export const SkuWidget = ({sku, onChange, props, children}) => {
    const [isOpen, setOpen] = useState(false);
    const [nextSku, setNextSku] = useState(sku);

    const onOpen = () => {
        setNextSku(sku);
        setOpen(true);
    }

    const onOk = () => {
        setOpen(false)
        if (onChange) {
            onChange(nextSku)
        }
    }

    const onCancel = () => {
        setOpen(false);
    }

    const onInputChange = (e) => {
        setNextSku(e.target.value);
    }

    return <div>
        <div style={{cursor: 'pointer', color: "#108ee9"}} onClick={onOpen}>{children}</div>
        <Modal width={400} open={isOpen} onOk={onOk} onCancel={onCancel}>
            <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col><Input style={{width: 300}} onChange={onInputChange} value={nextSku} /></Col>
            </Row>
        </Modal>
    </div>
}